<template>
  <form action="" method="post" name="ListSelect" id="ListSelect">
    <div class="os_noticeRes">
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <div class="osResHeader padLS padRS">
        <h1 class="txtC">
          <img :src="topImgPath">
        </h1>
      </div>

      <div class="padTS padBL padLS padRS" style="color:#222;" v-if="scheduleList.length > 0">
        <div class="padTL padBL txtC" style="background-color:#f5f5f5;max-width:710px;margin:0px auto;">
          <p class="widM fntH5">
            <span class="disBl fntP" style="margin-top:0.2em;">약관에 대해 <span
              style="color:#1874cd;">{{ $dayjs(scheduleList[0].terms_confirm_date || undefined).format('YYYY년 MM월 DD일') }}</span>에 동의하셨습니다.</span>
          </p>
        </div>

        <!-- 주사업자 -->
        <div>
          <div class="marTL marBL padTL padBL padLL padRL"
               style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">
            <h2 class=" fntP fntL bolder" style="padding:0px;color:#1874cd;">
            <span class="disIb marRS" style="vertical-align:middle;">
                <img src="./img/loginIcon_date.png" alt="">
            </span>일정선택
            </h2>
            <div class="osResTbBlock marTM padTM fntP" style="border-top:1px solid #d5d5d5;text-indent:1em">
              <table class="osResTbRow" style="border-top:1px solid #ddd;">
                <caption>
                  <p class="hide">행사일정 표입니다.</p>
                </caption>
                <colgroup>
                  <col style="width:30%">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">대상</th>
                  <td style="padding:0.8em;text-indent:0px;">
                    {{ scheduleList[0].mas_name }} 님
                  </td>
                </tr>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">일정</th>
                  <td style="padding:0.8em;text-indent:0px;">{{ scheduleList[0].mas_team }}</td>
                </tr>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">날짜</th>
                  <td style="padding:0.8em;text-indent:0px;">{{ scheduleList[0].mas_period }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="marTL marBL padTL padBL padLL padRL"
               style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">
            <h2 class=" fntP fntL bolder" style="padding:0px;color:#1874cd;">
            <span class="disIb marRS" style="vertical-align:middle;">
                <img src="./img/joinIcon_j.png" alt="">
            </span>여행자 정보
            </h2>
            <div class="osResTbBlock marTM padTM fntP" style="border-top:1px solid #d5d5d5;text-indent:1em">
              <table class="osResTbRow" style="border-top:1px solid #ddd;">
                <caption>
                  <p class="hide">행사일정 표입니다.</p>
                </caption>
                <colgroup>
                  <col style="width:30%">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">탑승자</th>
                  <!--    arr.join(', ')              join -->
                  <td style="padding:0.8em;text-indent:0px;">{{ [scheduleList[0].traveler_master, scheduleList[0].traveler_sub, scheduleList[0].traveler_family1,
                    scheduleList[0].traveler_family2, scheduleList[0].traveler_family3, scheduleList[0].traveler_family4, scheduleList[0].traveler_family5,
                    scheduleList[0].traveler_family6, scheduleList[0].traveler_family7, scheduleList[0].traveler_family8, scheduleList[0].traveler_family9, scheduleList[0]
                      .traveler_family10].filter(Boolean).join(', ') }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 출국일정 항공일정이 2개 존재 => 국내 경유지 존재 -->
          <mas-domestic-transit-schedule v-if="scheduleList.length === 2" :schedule-list="scheduleList" @printScr="printScr" />
          <!-- 출국일정 항공일정이 3개 국외 경유지 존재 => 국외 경유지 존재 -->
          <mas-international-transit-schedule v-else-if="scheduleList.length === 3" :schedule-list="scheduleList" @printScr="printScr" />
          <!-- 출국일정 경유지가 없는 경우-->
          <mas-international-schedule v-else :schedule-list="scheduleList" @printScr="printScr" />
        </div>

        <!-- 부 사업자 -->
        <div v-if="!!scheduleList[0].sub_name">
          <div class="marTL marBL padTL padBL padLL padRL"
               style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">
            <h2 class=" fntP fntL bolder" style="padding:0px;color:#1874cd;">
                      <span class="disIb marRS" style="vertical-align:middle;">
                          <img src="./img/loginIcon_date.png" alt="">
                      </span>일정선택
            </h2>
            <div class="osResTbBlock marTM padTM fntP" style="border-top:1px solid #d5d5d5;text-indent:1em">
              <table class="osResTbRow" style="border-top:1px solid #ddd;">
                <caption>
                  <p class="hide">행사일정 표입니다.</p>
                </caption>
                <colgroup>
                  <col style="width:30%">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">대상</th>
                  <td style="padding:0.8em;text-indent:0px;">
                    {{scheduleList[0].sub_name}} 님
                    <input type="hidden" id="sub_name" name="sub_name" value="LUKE STEPHEN PAIK">
                  </td>
                </tr>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">일정</th>
                  <td style="padding:0.8em;text-indent:0px;">{{scheduleList[0].sub_team}}</td>
                </tr>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">날짜</th>
                  <td style="padding:0.8em;text-indent:0px;">{{scheduleList[0].sub_period}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="marTL marBL padTL padBL padLL padRL"
               style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">
            <h2 class=" fntP fntL bolder" style="padding:0px;color:#1874cd;">
                      <span class="disIb marRS" style="vertical-align:middle;">
                          <img src="./img/joinIcon_j.png" alt="">
                      </span>여행자 정보
            </h2>
            <div class="osResTbBlock marTM padTM fntP" style="border-top:1px solid #d5d5d5;text-indent:1em">
              <table class="osResTbRow" style="border-top:1px solid #ddd;">
                <caption>
                  <p class="hide">행사일정 표입니다.</p>
                </caption>
                <colgroup>
                  <col style="width:30%">
                  <col style="width:auto">
                </colgroup>
                <tbody>
                <tr>
                  <th class="fntH5 txtL moTxtC" style="padding:0.8em;text-indent:0px;">탑승자</th>
                  <td style="padding:0.8em;text-indent:0px;">{{ [scheduleList[0].traveler_master, scheduleList[0].traveler_sub, scheduleList[0].traveler_family1,
                    scheduleList[0].traveler_family2, scheduleList[0].traveler_family3, scheduleList[0].traveler_family4, scheduleList[0].traveler_family5,
                    scheduleList[0].traveler_family6, scheduleList[0].traveler_family7, scheduleList[0].traveler_family8, scheduleList[0].traveler_family9, scheduleList[0]
                      .traveler_family10].filter(Boolean).join(', ') }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 입국일정 항공일정이 2개 존재 => 국내 경유지 존재-->
          <sub-domestic-transit-schedule v-if="scheduleList.length === 2" :schedule-list="scheduleList" @printScr="printScr" />
          <!-- 입국일정 항공일정이 3개 => 국외 경유지 존재 -->
          <sub-international-transit-schedule v-else-if="scheduleList.length === 3" :schedule-list="scheduleList" @printScr="printScr" />
          <!-- 입국일정 경유지가 없는 경우 -->
          <sub-international-schedule v-else :schedule-list="scheduleList" @printScr="printScr" />
        </div>
        <div class="marTL padTL padBL padLL padRL"
             style="max-width:710px;margin-left:auto;margin-right:auto;border:3px solid #d5d5d5;">
          <!-- 문자 -->
          <form action="#none" class="clearfix">
            <p class="floL fntP bolder moTxtC" style="width:28%;line-height:2.5em;">항공일정 문자 보내기</p>
            <p class="floL padBS" style="width:15%">
              <select id="phone1" name="phone1" class="disBl fntP" style="width:100%;height:2.5em;" v-model="phone1">
                <option value="010" selected>010</option>
                <option value="011">011</option>
                <option value="016">016</option>
                <option value="017">017</option>
                <option value="018">018</option>
                <option value="019">019</option>
                <option value="0130">0130</option>
              </select>
            </p>
            <span class="disIb txtC pcView" style="float:left;width:4%;line-height:2.5em;text-indent:0px;">-</span>
            <p class="floL padBS" style="width:15%">
              <input type="text" id="phone2" name="phone2" class="disBl fntP" style="width:100%;height:2.5em;"
                     maxlength="4" size="4" v-model="phone2" @input="phone2 = phone2.replace(/[^0-9]/g, '')">
            </p>
            <span class="disIb txtC pcView" style="float:left;width:4%;line-height:2.5em;text-indent:0px;">-</span>
            <p class="floL padBM" style="width:15%;">
              <input type="text" id="phone3" name="phone3" class="disBl fntP" style="width:100%;height:2.5em;"
                     maxlength="4" size="4" v-model="phone3" @input="phone3 = phone3.replace(/[^0-9]/g, '')">
            </p>
            <p class="floR padBM fntP" style="width:16%;">
              <input type="button" value="문자발송" @click.prevent="pushSMS"
                     style="background-color:#0569c9;width:100%;height:2.5em;padding:0px;line-height:2.5em;color:#fff;border:0px;font-weight:bold;">
            </p>
          </form>
          <!-- 참고사항 -->
          <div class="osResNoticeList padTM padBM padLM padRM" style="clear:both;background-color:#f5f5f5;">
            <ul style="list-style: none;">
              <li>※ 항공권 발행 당사자(여행 참가자) 외 타인의 번호로 SMS를 발송하지 않도록 주의해 주시기 바랍니다.</li>
              <li>※ 휴대폰 번호는 SMS 전송이 완료된 후 삭제되며, 별도로 보관하지 않습니다.</li>
            </ul>
          </div>
        </div>

        <div class="marTL padTL padBL padLL padRL"
             style="background-color:#f5f5f5;max-width:710px;margin-left:auto;margin-right:auto;">
          <p class="marBM fntH6 bolder">
            공지사항
          </p>
          <div class="quill-viewer" v-html="scheduleList[0].surv_notice"></div>
        </div>

        <p class="marTL txtC">
          <!--input type="button" value="확인" onclick="closePop();return false;" class="fntP bolder" style="background-color:#1874cd;width:8em;height:2.5em;color:#fff;border:0px;"-->
        </p>
      </div>
    </div>
  </form>

</template>

<script>
import axios from 'axios'
import MasDomesticTransitSchedule from './components/masDomesticTransitSchedule.vue'
import MasInternationalTransitSchedule from './components/masInternationalTransitSchedule.vue'
import MasInternationalSchedule from './components/masInternationalSchedule.vue'
import SubDomesticTransitSchedule from '@/views/nca/components/subDomesticTransicSchedule.vue'
import SubInternationalTransitSchedule from '@/views/nca/components/subInternationalTransitSchedule.vue'
import SubInternationalSchedule from '@/views/nca/components/subInternationalSchedule.vue'
export default {
  name: 'NcaSchedule',
  props: {
    survNo: {
      type: [String, Number],
      required: true
    },
    userNo: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    SubInternationalSchedule,
    SubInternationalTransitSchedule,
    SubDomesticTransitSchedule,
    MasDomesticTransitSchedule,
    MasInternationalTransitSchedule,
    MasInternationalSchedule},
  data () {
    return {
      aboInfo: {aboNo: '', aboName: ''},
      surv_no: 0,
      user_no: 0,
      topImgPath: './img/top.gif',
      scheduleList: [],
      phone1: '010',
      phone2: '',
      phone3: '',
      isLoading: false
    }
  },
  async mounted () {
    if (!this.isPreviewMode) {
      const isLoggedIn = await this.checkLogin()
      if (!isLoggedIn) return
    }

    this.surv_no = this.survNo
    this.user_no = this.userNo
    await this.getSurveyDetail(this.surv_no)
  },
  destroyed () {
  },
  computed: {
    isPreviewMode () {
      return this.$route.query.preview === 'true'
    }
  },
  methods: {
    checkLogin: async function () {
      this.isLoading = true
      try {
        const response = await axios.get(
          process.env.OCC_ROOT_URL + '/sso/authorizeEvent',
          { withCredentials: true }
        )
        if (response.data.header.status === 'ERROR') {
          window.location.href = `${process.env.AMWAY_ROOT_URL}/login`
          return false
        }
        if (response.data.customerUid && response.data.customerUid !== 'none') {
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
          return true
        }
        return false
      } catch (e) {
        alert('로그인이 필요합니다.')
        window.location.href = `${process.env.AMWAY_ROOT_URL}/login`
        return false
      } finally {
        this.isLoading = false
      }
    },
    async getSurveyDetail (survNo) {
      this.isLoading = true

      try {
        const params = {
          surv_no: survNo,
          mode: this.isPreviewMode ? 'preview_schedule' : 'schedule',
          user_id: this.isPreviewMode ? this.user_no : this.aboInfo.aboNo,
          user_no: this.isPreviewMode ? undefined : this.user_no
        }
        const {data} = await axios.get(
          process.env.AWS_GATEWAY_URL_V2 + `/event-admin/nca/survey-detail`,
          {params}
        )
        if (!data) {
          console.log('Invalid response:', data)
          return
        }
        if (data.length === 0) {
          alert('항공정보가 올바르지 않습니다.')
          this.$router.push({name: 'pageNotFound'})
        }
        this.scheduleList = data
        this.topImgPath = data[0].surv_top_img.replace(/^s3:\/\//, 'https://')
      } catch (e) {
        console.error('getSurveyDetail error:', e)
      } finally {
        this.isLoading = false
      }
    },
    printScr () {
      window.print()
    },
    isValidPhoneNumber () {
      if (!this.phone1 || !this.phone2 || !this.phone3) {
        alert('전화번호를 모두 입력해주세요.')
        return false
      }
      if (this.phone2.length < 3 || this.phone3.length !== 4) {
        alert('전화번호 형식이 올바르지 않습니다.')
        return false
      }
      const fullPhone = `${this.phone1}-${this.phone2}-${this.phone3}`
      const phoneRegex = /^01(0|1|[6-9])-\d{3,4}-\d{4}$/

      if (!phoneRegex.test(fullPhone)) {
        alert('유효하지 않은 휴대폰 번호입니다.')
        return false
      }
      return true
    },
    makeContentSms () {
      let smsLines = []
      const cnt = this.scheduleList.length
      const _ = this.$_

      if (cnt === 2) {
        const schedule1 = this.scheduleList[0]
        const schedule2 = this.scheduleList[1]
        smsLines.push(
          `[${_.defaultTo(schedule1.mas_team, '')}]`,
          `▶일정: ${_.defaultTo(schedule1.mas_period, '')}`,
          `▶회원명: ${_.defaultTo(schedule1.mas_name, '')}`,
          ``,
          `▶${_.defaultTo(schedule1.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule1.mas_departure_start_date, '')} ${_.defaultTo(schedule1.mas_departure_start, '')} ${_.defaultTo(schedule1.mas_departure_start_time, '')}${_.isNil(schedule1.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_departure_end_date, '')} ${_.defaultTo(schedule1.mas_departure_end, '')} ${_.defaultTo(schedule1.mas_departure_end_time, '')}${_.isNil(schedule1.mas_departure_flight) ? '' : '(' + schedule1.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule1.mas_return_start_date, '')} ${_.defaultTo(schedule1.mas_return_start, '')} ${_.defaultTo(schedule1.mas_return_start_time, '')}${_.isNil(schedule1.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_return_end_date, '')} ${_.defaultTo(schedule1.mas_return_end, '')} ${_.defaultTo(schedule1.mas_return_end_time, '')}${_.isNil(schedule1.mas_return_flight) ? '' : '(' + schedule1.mas_return_flight + ')'}`,
          ``,
          `▶${_.defaultTo(schedule2.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule2.mas_departure_start_date, '')} ${_.defaultTo(schedule2.mas_departure_start, '')} ${_.defaultTo(schedule2.mas_departure_start_time, '')}${_.isNil(schedule2.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule2.mas_departure_end_date, '')} ${_.defaultTo(schedule2.mas_departure_end, '')} ${_.defaultTo(schedule2.mas_departure_end_time, '')}${_.isNil(schedule2.mas_departure_flight) ? '' : '(' + schedule2.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule2.mas_return_start_date, '')} ${_.defaultTo(schedule2.mas_return_start, '')} ${_.defaultTo(schedule2.mas_return_start_time, '')}${_.isNil(schedule2.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule2.mas_return_end_date, '')} ${_.defaultTo(schedule2.mas_departure_end, '')} ${_.defaultTo(schedule2.mas_departure_end_time, '')}${_.isNil(schedule2.mas_departure_flight) ? '' : '(' + schedule2.mas_departure_flight + ')'}`
        )
        if (schedule1.sub_name) {
          smsLines.push(
            ``,
            `[${_.defaultTo(schedule1.sub_team, '')}]`,
            `▶일정: ${_.defaultTo(schedule1.sub_period, '')}`,
            `▶회원명: ${_.defaultTo(schedule1.sub_name, '')}`,
            ``,
            `▶${_.defaultTo(schedule1.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule1.sub_departure_start_date, '')} ${_.defaultTo(schedule1.sub_departure_start, '')} ${_.defaultTo(schedule1.sub_departure_start_time, '')}${_.isNil(schedule1.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_departure_end_date, '')} ${_.defaultTo(schedule1.sub_departure_end, '')} ${_.defaultTo(schedule1.sub_departure_end_time, '')}${_.isNil(schedule1.sub_departure_flight) ? '' : '(' + schedule1.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule1.sub_return_start_date, '')} ${_.defaultTo(schedule1.sub_return_start, '')} ${_.defaultTo(schedule1.sub_return_start_time, '')}${_.isNil(schedule1.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_return_end_date, '')} ${_.defaultTo(schedule1.sub_return_end, '')} ${_.defaultTo(schedule1.sub_return_end_time, '')}${_.isNil(schedule1.sub_return_flight) ? '' : '(' + schedule1.sub_return_flight + ')'}`,
            ``,
            `▶${_.defaultTo(schedule2.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule2.sub_departure_start_date, '')} ${_.defaultTo(schedule2.sub_departure_start, '')} ${_.defaultTo(schedule2.sub_departure_start_time, '')}${_.isNil(schedule2.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule2.sub_departure_end_date, '')} ${_.defaultTo(schedule2.sub_departure_end, '')} ${_.defaultTo(schedule2.sub_departure_end_time, '')}${_.isNil(schedule2.sub_departure_flight) ? '' : '(' + schedule2.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule2.sub_return_start_date, '')} ${_.defaultTo(schedule2.sub_return_start, '')} ${_.defaultTo(schedule2.sub_return_start_time, '')}${_.isNil(schedule2.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule2.sub_return_end_date, '')} ${_.defaultTo(schedule2.sub_departure_end, '')} ${_.defaultTo(schedule2.sub_departure_end_time, '')}${_.isNil(schedule2.sub_departure_flight) ? '' : '(' + schedule2.sub_departure_flight + ')'}`
          )
        }
      } else if (cnt === 3) {
        const schedule1 = this.scheduleList[0] // 국내
        const schedule2 = this.scheduleList[1] // 경유
        const schedule3 = this.scheduleList[2] // 국제

        smsLines.push(
          `[${_.defaultTo(schedule1.mas_team, '')}]`,
          `▶일정: ${_.defaultTo(schedule1.mas_period, '')}`,
          `▶회원명: ${_.defaultTo(schedule1.mas_name, '')}`,
          ``,
          `▶${_.defaultTo(schedule1.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule1.mas_departure_start_date, '')} ${_.defaultTo(schedule1.mas_departure_start, '')} ${_.defaultTo(schedule1.mas_departure_start_time, '')}${_.isNil(schedule1.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_departure_end_date, '')} ${_.defaultTo(schedule1.mas_departure_end, '')} ${_.defaultTo(schedule1.mas_departure_end_time, '')}${_.isNil(schedule1.mas_departure_flight) ? '' : '(' + schedule1.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule1.mas_return_start_date, '')} ${_.defaultTo(schedule1.mas_return_start, '')} ${_.defaultTo(schedule1.mas_return_start_time, '')}${_.isNil(schedule1.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_return_end_date, '')} ${_.defaultTo(schedule1.mas_return_end, '')} ${_.defaultTo(schedule1.mas_return_end_time, '')}${_.isNil(schedule1.mas_return_flight) ? '' : '(' + schedule1.mas_return_flight + ')'}`,
          ``,
          `▶${_.defaultTo(schedule2.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule2.mas_departure_start_date, '')} ${_.defaultTo(schedule2.mas_departure_start, '')} ${_.defaultTo(schedule2.mas_departure_start_time, '')}${_.isNil(schedule2.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule2.mas_departure_end_date, '')} ${_.defaultTo(schedule2.mas_departure_end, '')} ${_.defaultTo(schedule2.mas_departure_end_time, '')}${_.isNil(schedule2.mas_departure_flight) ? '' : '(' + schedule2.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule2.mas_return_start_date, '')} ${_.defaultTo(schedule2.mas_return_start, '')} ${_.defaultTo(schedule2.mas_return_start_time, '')}${_.isNil(schedule2.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule2.mas_return_end_date, '')} ${_.defaultTo(schedule2.mas_return_end, '')} ${_.defaultTo(schedule2.mas_return_end_time, '')}${_.isNil(schedule2.mas_return_flight) ? '' : '(' + schedule2.mas_return_flight + ')'}`,
          ``,
          `▶${_.defaultTo(schedule3.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule3.mas_departure_start_date, '')} ${_.defaultTo(schedule3.mas_departure_start, '')} ${_.defaultTo(schedule3.mas_departure_start_time, '')}${_.isNil(schedule3.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule3.mas_departure_end_date, '')} ${_.defaultTo(schedule3.mas_departure_end, '')} ${_.defaultTo(schedule3.mas_departure_end_time, '')}${_.isNil(schedule3.mas_departure_flight) ? '' : '(' + schedule3.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule3.mas_return_start_date, '')} ${_.defaultTo(schedule3.mas_return_start, '')} ${_.defaultTo(schedule3.mas_return_start_time, '')}${_.isNil(schedule3.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule3.mas_return_end_date, '')} ${_.defaultTo(schedule3.mas_return_end, '')} ${_.defaultTo(schedule3.mas_return_end_time, '')}(${_.defaultTo(schedule3.mas_return_flight, '')})`
        )
        if (schedule2.sub_name) {
          smsLines.push(
            ``,
            `[${_.defaultTo(schedule1.sub_team, '')}]`,
            `▶일정: ${_.defaultTo(schedule1.sub_period, '')}`,
            `▶회원명: ${_.defaultTo(schedule1.sub_name, '')}`,
            ``,
            `▶${_.defaultTo(schedule1.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule1.sub_departure_start_date, '')} ${_.defaultTo(schedule1.sub_departure_start, '')} ${_.defaultTo(schedule1.sub_departure_start_time, '')}${_.isNil(schedule1.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_departure_end_date, '')} ${_.defaultTo(schedule1.sub_departure_end, '')} ${_.defaultTo(schedule1.sub_departure_end_time, '')}${_.isNil(schedule1.sub_departure_flight) ? '' : '(' + schedule1.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule1.sub_return_start_date, '')} ${_.defaultTo(schedule1.sub_return_start, '')} ${_.defaultTo(schedule1.sub_return_start_time, '')}${_.isNil(schedule1.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_return_end_date, '')} ${_.defaultTo(schedule1.sub_return_end, '')} ${_.defaultTo(schedule1.sub_return_end_time, '')}${_.isNil(schedule1.sub_return_flight) ? '' : '(' + schedule1.sub_return_flight + ')'}`,
            ``,
            `▶${_.defaultTo(schedule2.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule2.sub_departure_start_date, '')} ${_.defaultTo(schedule2.sub_departure_start, '')} ${_.defaultTo(schedule2.sub_departure_start_time, '')}${_.isNil(schedule2.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule2.sub_departure_end_date, '')} ${_.defaultTo(schedule2.sub_departure_end, '')} ${_.defaultTo(schedule2.sub_departure_end_time, '')}${_.isNil(schedule2.sub_departure_flight) ? '' : '(' + schedule2.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule2.sub_return_start_date, '')} ${_.defaultTo(schedule2.sub_return_start, '')} ${_.defaultTo(schedule2.sub_return_start_time, '')}${_.isNil(schedule2.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule2.sub_return_end_date, '')} ${_.defaultTo(schedule2.sub_return_end, '')} ${_.defaultTo(schedule2.sub_return_end_time, '')}${_.isNil(schedule2.sub_return_flight) ? '' : '(' + schedule2.sub_return_flight + ')'}`,
            ``,
            `▶${_.defaultTo(schedule3.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule3.sub_departure_start_date, '')} ${_.defaultTo(schedule3.sub_departure_start, '')} ${_.defaultTo(schedule3.sub_departure_start_time, '')}${_.isNil(schedule3.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule3.sub_departure_end_date, '')} ${_.defaultTo(schedule3.sub_departure_end, '')} ${_.defaultTo(schedule3.sub_departure_end_time, '')}${_.isNil(schedule3.sub_departure_flight) ? '' : '(' + schedule3.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule3.sub_return_start_date, '')} ${_.defaultTo(schedule3.sub_return_start, '')} ${_.defaultTo(schedule3.sub_return_start_time, '')}${_.isNil(schedule3.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule3.sub_return_end_date, '')} ${_.defaultTo(schedule3.sub_return_end, '')} ${_.defaultTo(schedule3.sub_return_end_time, '')}${_.isNil(schedule3.sub_return_flight) ? '' : '(' + schedule3.sub_return_flight + ')'}`
          )
        }
      } else {
        const schedule1 = this.scheduleList[0]

        smsLines.push(
          `[${_.defaultTo(schedule1.mas_team, '')}]`,
          `▶일정: ${_.defaultTo(schedule1.mas_period, '')}`,
          `▶회원명: ${_.defaultTo(schedule1.mas_name, '')}`,
          ``,
          `▶${_.defaultTo(schedule1.mas_flight_gubun, '')}`,
          `${_.defaultTo(schedule1.mas_departure_start_date, '')} ${_.defaultTo(schedule1.mas_departure_start, '')} ${_.defaultTo(schedule1.mas_departure_start_time, '')}${_.isNil(schedule1.mas_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_departure_end_date, '')} ${_.defaultTo(schedule1.mas_departure_end, '')} ${_.defaultTo(schedule1.mas_departure_end_time, '')}${_.isNil(schedule1.mas_departure_flight) ? '' : '(' + schedule1.mas_departure_flight + ')'}`,
          `${_.defaultTo(schedule1.mas_return_start_date, '')} ${_.defaultTo(schedule1.mas_return_start, '')} ${_.defaultTo(schedule1.mas_return_start_time, '')}${_.isNil(schedule1.mas_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.mas_return_end_date, '')} ${_.defaultTo(schedule1.mas_return_end, '')} ${_.defaultTo(schedule1.mas_return_end_time, '')}${_.isNil(schedule1.mas_return_flight) ? '' : '(' + schedule1.mas_return_flight + ')'}`
        )
        if (schedule1.sub_name) {
          smsLines.push(
            ``,
            `[${_.defaultTo(schedule1.sub_team, '')}]`,
            `▶일정: ${_.defaultTo(schedule1.sub_period, '')}`,
            `▶회원명: ${_.defaultTo(schedule1.sub_name, '')}`,
            ``,
            `▶${_.defaultTo(schedule1.sub_flight_gubun, '')}`,
            `${_.defaultTo(schedule1.sub_departure_start_date, '')} ${_.defaultTo(schedule1.sub_departure_start, '')} ${_.defaultTo(schedule1.sub_departure_start_time, '')}${_.isNil(schedule1.sub_departure_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_departure_end_date, '')} ${_.defaultTo(schedule1.sub_departure_end, '')} ${_.defaultTo(schedule1.sub_departure_end_time, '')}${_.isNil(schedule1.sub_departure_flight) ? '' : '(' + schedule1.sub_departure_flight + ')'}`,
            `${_.defaultTo(schedule1.sub_return_start_date, '')} ${_.defaultTo(schedule1.sub_return_start, '')} ${_.defaultTo(schedule1.sub_return_start_time, '')}${_.isNil(schedule1.sub_return_start_date) ? '' : '→'}${_.defaultTo(schedule1.sub_return_end_date, '')} ${_.defaultTo(schedule1.sub_return_end, '')} ${_.defaultTo(schedule1.sub_return_end_time, '')}${_.isNil(schedule1.sub_return_flight) ? '' : '(' + schedule1.sub_return_flight + ')'}`
          )
        }
      }
      smsLines.push(
        '',
        `▶항공 담당자: ${_.defaultTo(this.scheduleList[0].surv_flight_manager, '')}`,
        '',
        'Amway Korea'
      )
      return smsLines.join('\n')
    },
    async pushSMS () {
      this.isLoading = true
      try {
        if (!this.isValidPhoneNumber()) {
          return
        }
        const phoneNumber = `${this.phone1}-${this.phone2}-${this.phone3}`
        let smsContent = this.makeContentSms()
        const data = {
          user_id: this.aboInfo.aboNo,
          mas_name: this.scheduleList[0].mas_name,
          to_phone: phoneNumber,
          sms_content: smsContent
        }
        const response = await axios.post(
          process.env.AWS_GATEWAY_URL_V2 + `/event/nca/sms`,
          data
        )
        console.log('문자가 발송 결과:', response)
        // 등록 성공 후 팝업 닫기
        alert('문자가 발송 되었습니다.')
      } catch (e) {
        console.error('수정 실패:', e)
        alert('문자가 발송 중 문제가 발생했습니다.')
      } finally {
        this.isLoading = false
      }
    }
  }

}
</script>

<style>
  @import './css/font_kr.css';
  @import './css/content_res_reset.css';
  @import './css/content_res_all.css';
  @import './css/content_oad_flight.css';
</style>



// WEBPACK FOOTER //
// src/views/nca/schedule.vue